import { USER_ROLES } from '../util/constants/AppConstants';
import { apiRequest, apiRequestDev } from './apiRequest';

export const getAllUsers = async (config) => apiRequestDev(config, '/users/all');

// export const getAllUsers = async (config) => apiRequest(config, '/users/all');

export const getMpps = async (config) => apiRequestDev(config, '/users/mpps');

export const getUserInfo = async (config, id) => apiRequest(config, `/users/info?id=${id}`);

export const getAdminPermissions = async (config, id) => apiRequestDev(config, `/users/permissions?id=${id}`);

export const getMpp = async (config, id) => apiRequestDev(config, `/users/mpp?id=${id}`);

export const getCity = async (config, id) => apiRequestDev(config, `/users/city?id=${id}`);

export const saveUser = async (
  config,
  id,
  firstname,
  lastname,
  email,
  phone,
  jobTitle,
  city,
  locationState,
  country,
  userRole,
  password,
  demo,
  bypass2fa = false,
) => {
  const { project } = USER_ROLES.find((role) => role.value === userRole);

  return apiRequest(config, `/users/${id}/update`, 'post', {
    firstname,
    lastname,
    email,
    phone,
    job_title: jobTitle,
    location_city: city,
    location_state: locationState,
    location_country: country,
    role: userRole,
    password,
    project,
    demo,
    bypass2fa,
  });
};

export const createUser = async (
  config,
  firstname,
  lastname,
  email,
  phone,
  password,
  jobTitle,
  city,
  locationState,
  country,
  userRole,
  demo,
  bypass2fa = false,
) => {
  const { project } = USER_ROLES.find((role) => role.value === userRole);

  return apiRequest(config, '/users/create', 'post', {
    firstname,
    lastname,
    email,
    phone,
    password,
    job_title: jobTitle,
    location_city: city,
    location_state: locationState,
    location_country: country,
    role: userRole,
    project,
    demo,
    bypass2fa,
  });
};

export const createAdmin = async (
  config,
  adminId,
  usersLimit,
  topicsPermission,
  groupsPermission,
  trendsPermission,
  districtPermission,
  mpPermission,
) => {
  return apiRequestDev(config, '/users/set_permissions', 'post', {
    admin_id: adminId,
    users_limit: usersLimit,
    topics_permission: topicsPermission,
    groups_permission: groupsPermission,
    trends_permission: trendsPermission,
    district_permission: districtPermission,
    mp_permission: mpPermission,
  });
};

export const assignMpp = async (config, stafferId, mppId) => {
  return apiRequestDev(config, '/users/assign_mpp', 'post', {
    staffer_id: stafferId,
    mpp_id: mppId,
  });
};

export const updateAdmin = async (
  config,
  adminId,
  usersLimit,
  topicsPermission,
  groupsPermission,
  trendsPermission,
  districtPermission,
  mpPermission,
) => {
  return apiRequestDev(config, '/users/update_permissions', 'patch', {
    admin_id: adminId,
    users_limit: usersLimit,
    topics_permission: topicsPermission,
    groups_permission: groupsPermission,
    trends_permission: trendsPermission,
    district_permission: districtPermission,
    mp_permission: mpPermission,
  });
};

export const updateMpp = async (config, stafferId, mppId) => {
  return apiRequestDev(config, '/users/update_mpp', 'patch', {
    staffer_id: stafferId,
    mpp_id: mppId,
  });
};

export const assignCity = async (config, councillorId, cityId) => {
  return apiRequestDev(config, '/users/assign_city', 'post', {
    councillor_id: councillorId,
    city_id: cityId,
  });
};

export const updateCity = async (config, councillorId, cityId) => {
  return apiRequestDev(config, '/users/update_city', 'patch', {
    councillor_id: councillorId,
    city_id: cityId,
  });
};

export const deleteCity = async (config, id) => apiRequestDev(config, `/users/city/${id}/delete`, 'delete');

export const deleteAdmin = async (config, id) => apiRequestDev(config, `/users/permissions/${id}/delete`, 'delete');

export const deleteMpp = async (config, id) => apiRequestDev(config, `/users/mpp/${id}/delete`, 'delete');

export const deleteUser = async (config, id) => apiRequest(config, `/users/${id}/delete`, 'delete');

export const assignTopics = async (config, userId, tags) => {
  return apiRequestDev(config, '/users/tags', 'post', {
    user_id: userId,
    tags,
  });
};

export const setMP = async (config, userId, enabled) => {
  return apiRequestDev(config, '/users/marketpulse', 'patch', {
    user_id: userId,
    enabled,
  });
};

export const deleteEmailSettings = async (config, userId) =>
  apiRequestDev(config, `/users/email_settings/${userId}/delete`, 'delete');

export const sendVerificationCode = async (config, phone) => {
  return apiRequestDev(config, '/auth/verification_sms', 'post', {
    phone,
  });
};

export const verifyCode = async (config, phone, code) => {
  return apiRequestDev(config, '/auth/verification_sms/validate', 'post', {
    phone,
    code,
  });
};
